export const buildNumber = '20260827.3';
export const version = 'main';
export const latestCommit = '4c3ecab253cd7de266f3c72ef6af07ec57a83425';
